import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ManagementCompanyAssetCertificationApplication =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ManagementCompanyAssetCertificationApplication, _BaseData);

  function ManagementCompanyAssetCertificationApplication() {
    _classCallCheck(this, ManagementCompanyAssetCertificationApplication);

    return _possibleConstructorReturn(this, _getPrototypeOf(ManagementCompanyAssetCertificationApplication).call(this, "ManagementCompanyAssetCertificationApplication"));
  }

  _createClass(ManagementCompanyAssetCertificationApplication, [{
    key: "GetByManagementCompany",
    value: function () {
      var _GetByManagementCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(managementCompanyId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByManagementCompany/").concat(managementCompanyId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByManagementCompany(_x) {
        return _GetByManagementCompany.apply(this, arguments);
      }

      return GetByManagementCompany;
    }()
  }, {
    key: "GetAllByManagementCompany",
    value: function () {
      var _GetAllByManagementCompany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(managementCompanyId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAllByManagementCompany/").concat(managementCompanyId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetAllByManagementCompany(_x2) {
        return _GetAllByManagementCompany.apply(this, arguments);
      }

      return GetAllByManagementCompany;
    }()
  }, {
    key: "GetAllExpiredManagementCompanies",
    value: function () {
      var _GetAllExpiredManagementCompanies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAllExpiredManagementCompanies")));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetAllExpiredManagementCompanies() {
        return _GetAllExpiredManagementCompanies.apply(this, arguments);
      }

      return GetAllExpiredManagementCompanies;
    }()
  }, {
    key: "GetAllCertifiedManagementCompanies",
    value: function () {
      var _GetAllCertifiedManagementCompanies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAllCertifiedManagementCompanies")));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetAllCertifiedManagementCompanies() {
        return _GetAllCertifiedManagementCompanies.apply(this, arguments);
      }

      return GetAllCertifiedManagementCompanies;
    }()
  }, {
    key: "IsDue",
    value: function () {
      var _IsDue = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(managementCompanyId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/IsDue/").concat(managementCompanyId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function IsDue(_x3) {
        return _IsDue.apply(this, arguments);
      }

      return IsDue;
    }()
  }, {
    key: "GetPropertyOptions",
    value: function () {
      var _GetPropertyOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(managementCompanyId, managementCompanyAssetCertificationApplicationId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/".concat(this._controller, "/GetPropertyOptions/").concat(managementCompanyId, "/").concat(managementCompanyAssetCertificationApplicationId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function GetPropertyOptions(_x4, _x5) {
        return _GetPropertyOptions.apply(this, arguments);
      }

      return GetPropertyOptions;
    }()
  }, {
    key: "GetDueReminderManagementCompanies",
    value: function () {
      var _GetDueReminderManagementCompanies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.get("/api/".concat(this._controller, "/GetDueAssetManagementCertificationsByUser")));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function GetDueReminderManagementCompanies() {
        return _GetDueReminderManagementCompanies.apply(this, arguments);
      }

      return GetDueReminderManagementCompanies;
    }()
  }, {
    key: "GetA5SubmittedCount",
    value: function () {
      var _GetA5SubmittedCount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.get("/api/".concat(this._controller, "/GetA5SubmittedCount")));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function GetA5SubmittedCount() {
        return _GetA5SubmittedCount.apply(this, arguments);
      }

      return GetA5SubmittedCount;
    }()
  }, {
    key: "ApplicationRejected",
    value: function () {
      var _ApplicationRejected = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(managementCompanyId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.post("/api/".concat(this._controller, "/ApplicationRejected/").concat(managementCompanyId)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function ApplicationRejected(_x6) {
        return _ApplicationRejected.apply(this, arguments);
      }

      return ApplicationRejected;
    }()
  }, {
    key: "ChangeStatusId",
    value: function () {
      var _ChangeStatusId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(managementCompany) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.post("/api/".concat(this._controller, "/ChangeStatusId"), managementCompany));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function ChangeStatusId(_x7) {
        return _ChangeStatusId.apply(this, arguments);
      }

      return ChangeStatusId;
    }()
  }, {
    key: "ListDownload",
    value: function () {
      var _ListDownload = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(managementCompanyAssetCertificationApplicationId) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.get("/api/".concat(this._controller, "/ListDownload/").concat(managementCompanyAssetCertificationApplicationId)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function ListDownload(_x8) {
        return _ListDownload.apply(this, arguments);
      }

      return ListDownload;
    }()
  }], [{
    key: "UploadAttachment",
    value: function UploadAttachment(files, managementCompanyId) {
      var formData = new FormData();
      files.forEach(function (file) {
        formData.append("files[]", file);
      });
      formData.append("requestId", managementCompanyId);
      return axios.post("api/ManagementCompanyAssetCertificationApplication/AddAttachments/".concat(managementCompanyId), formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }
  }]);

  return ManagementCompanyAssetCertificationApplication;
}(BaseData);

export default new ManagementCompanyAssetCertificationApplication();